import React from 'react';
import { connect, useHistory } from 'umi';
import ContentBody from '@op/components/ContentBody';
import { Layout, Button, Table } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
// 新增、编辑弹窗和表单
import FormModelPopup from './FormModelPopup';
import useTableData from './hooks/useTableData';
import CardCommon from '@op/components/CardCommon';
import './index.scss';
import { WeeklyReportConfiguration } from '@op/operationLog/pages';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import useWeeklyReportPermission from '../hooks/permission';
import { PAGE_NAME } from '@op/constants/page';
import TableCommonHook from '@op/components/TableCommonHook';
import { DBO_TM, DBO_U } from '@op/utils/format';
import SvgIcon from '@home/components/SvgIcon';
import { handleKeyWords, handleTags } from './utils';
import { useTableColumns } from './hooks/useTableColumns'; 
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';
const { expandable, draggable, sortable } = Table.addons;
const { Content } = Layout;

function Configuration({ gameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: WeeklyReportConfiguration });
  const history = useHistory();
  const { formatMessage } = useLanguage();
  const HIDE_TAG = useFrontWebConfig({
    keys: 'hide_weekly_report_tags',
  });

  const {
    records,
    getRecordsData,
    handleSortEffectiveTime,
    loading,
    draggableRowKeys,
    onDragEnd,
    expandedKeys,
    setExpandedKeys,
  } = useTableData({
    gameInfo,
  });

  const { canEditConfig, loading: permissionLoading } =
    useWeeklyReportPermission({
      gameInfo,
    });

  const {
    sorts,
    setSorts,
    relations,
    operationColumns,
    addVersion,
    visible,
    params,
    type,
    closeModal,
    handleApiStatus,
  } = useTableColumns({
    records,
    getRecordsData,
    canEditConfig,
  });

  return (
    <Content className="dbo-page dbo-weekly-report-configuration">
      <ContentBody
        className="dbo-weekly-report-configuration-body"
        pageName={
          permissionLoading || canEditConfig
            ? undefined
            : PAGE_NAME.CONFIGURATION
        }
        contentHeard={
          <Content.Header
            showBackButton
            onBackButtonClick={() => history.goBack()}
            title={formatMessage(PAGE_NAME.CONFIGURATION)}
          ></Content.Header>
        }
      >
        <>
          {canEditConfig && (
            <Button
              type="primary"
              style={{ marginBottom: 20 }}
              onClick={() => addVersion()}
            >
              {formatMessage('Add a new version')}
            </Button>
          )}
        </>
        <CardCommon
          loading={loading}
          empty={records.length === 0}
          loadingHeight={500}
        >
          {/* 表单主体 */}
          <TableCommonHook
            className="dbo-weekly-report-configuration-table"
            disableTextOverflow={true}
            records={records}
            bordered
            minWidth={1500}
            hasPageable={false}
            recordKey={'tableId'}
            columns={[
              {
                key: 'version',
                header: formatMessage('Version'),
                render: (record) => (
                  <span style={{ marginLeft: 4, verticalAlign: 'middle' }}>
                    {record.version_name}
                  </span>
                ),
                width: 150,
              },
              {
                key: 'modelDrag',
                header: '',
                width: 40,
              },
              {
                key: 'model',
                header: formatMessage('Module'),
                render: (record) => record.module_name || null,
                width: 180,
              },
              {
                key: 'keyWords',
                header: formatMessage('Keywords'),
                render: (record) => {
                  return handleKeyWords(record.keywords);
                },
              },
              ...(HIDE_TAG
                ? []
                : [
                    {
                      key: 'tags',
                      header: formatMessage('Tags'),
                      render: (record) => {
                        return handleTags(record.tags);
                      },
                    },
                  ]),
              {
                key: 'effectiveTime',
                header: formatMessage('Effective Date'),
                render: ({ effective_start_time, effective_end_time }) => {
                  if (effective_start_time) {
                    return DBO_TM.timeTitle({
                      start_time: effective_start_time,
                      end_time: effective_end_time,
                      date_type: 'daily',
                    });
                  }

                  return '-';
                },
                width: 217,
              },
              {
                key: 'whitePaper',
                header: formatMessage('White Paper'),
                width: 140,
                render: ({ white_paper }) => {
                  if (!!white_paper) {
                    return (
                      <div className="dbo-button-externa-link">
                        <Button
                          type="link"
                          onClick={() => DBO_U.open(white_paper)}
                        >
                          {formatMessage('Link')}
                          <SvgIcon type="link-to" />
                        </Button>
                      </div>
                    );
                  }
                  return '';
                },
              },
              ...operationColumns,
            ]}
            rowClassName={(record) => {
              return !draggableRowKeys.includes(record.tableId)
                ? 'dbo-disable-draggable-row'
                : '';
            }}
            addons={[
              expandable({
                expandedKeys,
                expand: (record) => record.childrenList || null,
                onExpandedKeysChange: (keys) => setExpandedKeys(keys),
                shouldRecordExpandable: (record) =>
                  Boolean(record.childrenList),
                targetColumnKey: 'version',
              }),
              draggable({
                expandedKeys,
                targetColumnKey: 'modelDrag',
                relations,
                dragType: 'row',
                childrenColName: 'childrenList',
                draggableRowKeys,
                onDragEnd,
              }),
              sortable({
                columns: ['effectiveTime'],
                value: sorts,
                onChange: (value, _context) => {
                  setSorts(value);
                  handleSortEffectiveTime(value[0]?.order);
                },
              }),
            ]}
          />
        </CardCommon>
        {/* 表单组件 */}
      </ContentBody>

      {/* 新增、编辑弹窗 */}
      <FormModelPopup
        params={params}
        type={type}
        visible={visible}
        handleApiStatus={handleApiStatus}
        gameInfo={gameInfo}
        closeModal={closeModal}
      ></FormModelPopup>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    whileGameInfo: opinionCommon.whileGameInfo,
  };
})(Configuration);
